import {MercantileType} from "../models/ParamSettings";
import {TransactionType} from "../models/Transaction";

export const srpsCalculation = (
    productName: string,
    quantity: number = 0,
    moisture: number,
    impurity: number,
    breakage: number,
    defect: number,
    hectoliter: number,
    calculationMethod: boolean,
    settings: any[],
    transactionType?: TransactionType
    ) => {

    let srpsQuantity: number = quantity;
    let percentMoisture: number = 0;
    let quantityMoisture: number = 0;
    let percentImpurity: number = 0;
    let quantityImpurity: number = 0;
    let percentHectoliter: number = 0;
    let quantityHectoliter: number = 0;
    let percentBreakage : number = 0;
    let quantityBreakage: number = 0;
    let percentDefect : number = 0;
    let quantityDefect: number = 0;
    let dryingCosts: number = 0; //troskovi susenja
    let dispersal: number = 0; //kalo

    if (calculationMethod) { //metod svodjenja na SRPS
        switch (productName) {

            case MercantileType.Wheat: {
                const wheatSettings = settings.find((product) => product.mercantile === MercantileType.Wheat);
                //@ts-ignore
                if (hectoliter === undefined || hectoliter === '' || hectoliter > parseFloat(wheatSettings?.hectoliter)) hectoliter = parseFloat(wheatSettings?.hectoliter);
                if (moisture !== undefined && moisture !== 0 && impurity !== undefined && impurity !== 0) {
                    //nema pozitivne bonifikacije na vlagu i primese
                    //negativna bonifikacija za vlagu metod 1:1 (vlaga u intervalu 14-15%); metod 1:2 (vlaga u intervalu 15-18%)
                    //negativna bonifikacija za primese metod 1:1 (primese u intervalu 2.5-6%); metod 1:2 (primese u intervalu 6-8%)
                    //hektolitar iznad Srps hektolitra se ne bonificira
                    let impurityPerc =  impurity < parseFloat(wheatSettings?.impurity)
                        ?
                        0
                        :
                        parseFloat(wheatSettings?.impurity) - impurity;
                    if (impurity > 6) impurityPerc += (6 - impurity);
                    percentImpurity = impurityPerc;
                    quantityImpurity = Math.round((impurityPerc * quantity) / 100);

                    let moisturePerc = moisture > parseFloat(wheatSettings?.moisture)
                        ?
                        parseFloat(wheatSettings?.moisture) - moisture
                        :
                        0;
                    if (moisture > 15) moisturePerc += (15 - moisture);
                    percentMoisture = moisturePerc;
                    quantityMoisture = Math.round((moisturePerc * quantity) / 100);

                    //hektolitar bez pozitivne bonifikacije
                    //negativna bonifikacija za hektoliter po metodu 1:1 za vrednosti 72-74,
                    //a po metodu 1:2 za vrednosti hektolitra 68-72
                    let hectoliterPerc = hectoliter > parseFloat(wheatSettings?.hectoliter)
                        ?
                        0
                        :
                        hectoliter - parseFloat(wheatSettings?.hectoliter);
                    if (hectoliter < 72) hectoliterPerc += (hectoliter - 72);
                    percentHectoliter = hectoliterPerc;
                    quantityMoisture = (moisturePerc * quantity) / 100;
                    quantityHectoliter = Math.round((percentHectoliter * quantity) / 100);

                    //kalo i rastur 0.5% na prijemu robe
                    if (transactionType === TransactionType.Export) {
                        dispersal = 0;
                    } else {
                        dispersal = wheatSettings?.calculateCalo === true ? Math.round((quantity * 0.5) / 100) : 0;
                    };

                    srpsQuantity = Math.round(
                        quantity * (
                            100 +
                            moisturePerc +
                            impurityPerc +
                            hectoliterPerc// -
                            //(wheatSettings?.calculateCalo === true ? 0.5 : 0)
                            ) / 100
                        ) - dispersal;
                    }
                else srpsQuantity = Math.round(quantity);
                break;
            };

            case MercantileType.OiledBeet: {
                const oiledBeetSettings = settings.find((product) => product.mercantile === MercantileType.OiledBeet);
                if (moisture !== undefined && moisture !== 0 && impurity !== undefined && impurity !== 0) {
                    //uljana repica vlage ispod % minimalne marginalne bonifikacije se ne bonificira
                    //negativna bonifikacija po metodu 1:1
                    const moisturePerc = moisture < parseFloat(oiledBeetSettings?.moistureMin)
                        ?
                        //pozitivna bonifikacija po metodu 0.5:1
                        (parseFloat(oiledBeetSettings?.moisture) - parseFloat(oiledBeetSettings?.moistureMin))/2
                        :
                        moisture < parseFloat(oiledBeetSettings?.moisture) ?
                            //pozitivna bonifikacija po metodu 0.5:1
                            (parseFloat(oiledBeetSettings?.moisture) - moisture)/2
                            :
                            //negativna bonifikacija po metodu 1:1, obracun za 2023. godinu
                            //parseFloat(oiledBeetSettings?.moisture) - moisture;
                            // //za 2024. i dalje 
                            // moisture <= 10 ? //negativna bonifikacija po metodu 1:1 za %vlage od baznog% do 10%
                            // (parseFloat(oiledBeetSettings?.moisture) - moisture)
                            // : //obracun za 2023: negativna bonifikacija po metodu 1:2 za %vlage od 10% do % maksimalne marginalne bonifikacije
                            // //plus negativna bonifikacija od baznog procenta vlage do 10% po metodu 1:1
                            // //obracun za 2024. dodaje se 1% fiksno ako je vlaga preko 10%
                            // //((parseFloat(oiledBeetSettings?.moisture) - 10)) + (10 - moisture)*2;
                            // (parseFloat(oiledBeetSettings?.moisture) - moisture - 1) 
                            
                            //za 2025. i dalje negativna bonifikacija po metodu 1:1
                            (parseFloat(oiledBeetSettings?.moisture) - moisture)
                    percentMoisture = moisturePerc;
                    quantityMoisture = Math.round((moisturePerc * quantity) / 100);

                    let impurityPerc = impurity < parseFloat(oiledBeetSettings?.impurity)
                        ?//uljana repica primesa ispod baznog % za obracun se ne bonificira pozitivno
                        0
                        :
                        //negativna bonifikacija po metodu 1:1 za primese od baznog% do 6%
                        parseFloat(oiledBeetSettings?.impurity) - impurity;
                        //obracun za 2023: negativna bonifikacija po metodu 1:2 za primese od 6% do % maksimalne marginalne bonifikacije
                        //plus negativna bonifikacija od baznog procenta do 6% po metodu 1:1
                        //obracun za 2024. dodaje se 1% fiksno ako je necistoca preko 6%
                        //((parseFloat(oiledBeetSettings?.impurity) - 6)) + (6 - impurity);
                    //obracun za 2025. i dalje
                    //za procente vece od 6% dodatna bonifikacija po metodu 1:2
                    if (impurity > 6) impurityPerc += (6 - impurity);
                    percentImpurity = impurityPerc;
                    percentImpurity = impurityPerc;
                    quantityImpurity = Math.round((impurityPerc * quantity) / 100);

                    if (transactionType === TransactionType.Export) {
                        dispersal = 0;
                    } else {
                        if (oiledBeetSettings?.calculateCalo === true) {
                            //ako je vlaga veca od 10% ili necistoca veca od 4%
                            //dodatni kalo od 0.5%, inace samo bazni kalo od 0.5%
                            const baseDispersal = moisture > 10 || impurity > 4 
                                ? Math.round(quantity / 100)    // 1% kalo
                                : Math.round((quantity * 0.5) / 100); // 0.5% kalo
                            dispersal = baseDispersal > 0 ? baseDispersal : 0;
                        } else {
                            dispersal = 0;
                        };
                    };

                    //troskovi susenja za vlagu vecu od 10%, svodjenje na vlagu od 8%
                    //4e/t/%
                    if (moisture > 10) dryingCosts = Math.round(4*quantity/1000*(moisture-8));

                    srpsQuantity = Math.round(quantity * (100 + moisturePerc + impurityPerc) / 100) - dispersal;
                }
                else srpsQuantity = Math.round(quantity);
                break;
            };

            case MercantileType.Barley: {
                const barleySettings = settings.find((product) => product.mercantile === MercantileType.Barley);
                //@ts-ignore
                if (hectoliter === undefined || hectoliter === '' || hectoliter > parseFloat(barleySettings?.hectoliter)) hectoliter = parseFloat(barleySettings?.hectoliter);
                if (moisture !== undefined && moisture !== 0 && impurity !== undefined && impurity !== 0) {
                    //nema pozitivne bonifikacije za necistocu
                    //negativna bonifikacija od baznog procenta po metodu 1:1
                    const impurityPerc = impurity < parseFloat(barleySettings?.impurity)
                        ?
                        0
                        :
                        (parseFloat(barleySettings?.impurity) - impurity);
                    percentImpurity = impurityPerc;
                    quantityImpurity = Math.round((impurityPerc * quantity) / 100);

                    //nema pozitivne bonifikacije za vlagu
                    //negativna bonifikacija za vlagu od baznog procenta po metodu 1:1
                    const moisturePerc = moisture < parseFloat(barleySettings?.moisture)
                        ?
                        0// (parseFloat(barleySettings?.moisture) - parseFloat(barleySettings?.moistureMin))
                        :
                        (parseFloat(barleySettings?.moisture) - moisture);
                    percentMoisture = moisturePerc;
                    quantityMoisture = Math.round((moisturePerc * quantity) / 100);

                    //hektolitar bez pozitivne bonifikacije
                    //negativna bonifikacija za hektolitar po metodu 1:1 za vrednosti manje od bazne vrednosti
                    let hectoliterPerc = hectoliter > parseFloat(barleySettings?.hectoliter)
                        ?
                        0
                        :
                        hectoliter - parseFloat(barleySettings?.hectoliter);
                    percentHectoliter = hectoliterPerc;
                    quantityHectoliter = Math.round((percentHectoliter * quantity) / 100);

                    //nema kalo i rastur
                    // //kalo i rastur 0.5% na prijemu robe
                    // if (transactionType === TransactionType.Export) {
                    //     dispersal = 0;
                    // } else {
                    //     dispersal = barleySettings?.calculateCalo === true ? Math.round((quantity * 0.5) / 100) : 0;
                    // };

                    srpsQuantity = Math.round(quantity * (100 + impurityPerc) / 100);
                    srpsQuantity = Math.round(
                        quantity * (
                            100 +
                            moisturePerc +
                            impurityPerc +
                            hectoliterPerc
                            ) / 100
                        );
                }
                else srpsQuantity = Math.round(quantity);
                break;
            };

            case MercantileType.Sunflower: {
                const sunflowerSettings = settings.find((product) => product.mercantile === MercantileType.Sunflower);

                if (moisture !== undefined && moisture !== 0 && impurity !== undefined && impurity !== 0) {
                    //suncokret vlage i primesa ispod % minimalne marginalne bonifikacije se ne bonificira
                    //pozitivna i negativna bonifikacija za vlagu i primese po metodu 1:1
                    const moisturePerc = moisture < parseFloat(sunflowerSettings?.moistureMin)
                        ?
                        (parseFloat(sunflowerSettings?.moisture) - parseFloat(sunflowerSettings?.moistureMin))
                        :
                        (parseFloat(sunflowerSettings?.moisture) - moisture);
                    percentMoisture = moisturePerc;
                    quantityMoisture = Math.round((moisturePerc * quantity) / 100);

                    const impurityPerc = impurity < parseFloat(sunflowerSettings?.impurityMin)
                        ?
                        (parseFloat(sunflowerSettings?.impurity) - parseFloat(sunflowerSettings?.impurityMin))
                        :
                        (parseFloat(sunflowerSettings?.impurity) - impurity);
                    percentImpurity = impurityPerc;
                    quantityImpurity = Math.round((impurityPerc * quantity) / 100);

                    //kalo i rastur 0.5% na prijemu robe
                    if (transactionType === TransactionType.Export) {
                        dispersal = 0;
                    } else {
                        dispersal = sunflowerSettings?.calculateCalo === true ? Math.round((quantity * 0.5) / 100) : 0;
                    };

                    //troskovi susenja za vlagu vecu od 12%, svodjenje na vlagu od 12%
                    //5e/t/%
                    if (moisture > 12) dryingCosts = Math.round(5*quantity/1000*(moisture-12));

                    srpsQuantity = Math.round(quantity * (100 + moisturePerc + impurityPerc) / 100) - dispersal;
                }
                else srpsQuantity = Math.round(quantity);
                break;
            };

            case MercantileType.Soya: {
                const soyaSettings = settings.find((product) => product.mercantile === MercantileType.Soya);

                if (moisture !== undefined && moisture !== 0 && impurity !== undefined && impurity !== 0) {
                    //soja vlage ispod % minimalne marginalne bonifikacije se ne bonificira
                    //pozitivna bonifikacija na vlagu po metodu 1:1
                    let moisturePerc = moisture < parseFloat(soyaSettings?.moistureMin)
                        ?
                        (parseFloat(soyaSettings?.moisture) - parseFloat(soyaSettings?.moistureMin))
                        :
                        (parseFloat(soyaSettings?.moisture) - moisture);
                    // //negativna bonifikacija do 15% vlage po metodu 1:1, za vise od 15% po metodu 1:2
                    //ukinuto od 09.08.2025.
                    // if (moisture > 15) moisturePerc += (15 - moisture);

                    percentMoisture = moisturePerc;
                    quantityMoisture = Math.round((moisturePerc * quantity) / 100);

                    //pozitivna bonifikacija za primese vece od % minimalne bonifikacije po metodu 1:1
                    //negativna bonifikacija za primese po metodu 1:1
                    const impurityPerc = impurity < parseFloat(soyaSettings?.impurityMin)
                        ?
                        parseFloat(soyaSettings?.impurity) - parseFloat(soyaSettings?.impurityMin)
                        :
                        (parseFloat(soyaSettings?.impurity) - impurity);
                    percentImpurity = impurityPerc;
                    quantityImpurity = Math.round((impurityPerc * quantity) / 100);

                    //od 08.09.2025. uvedeni troskovi susenja za soju
                    //troskovi susenja za vlagu vecu od 14%, svodjenje na vlagu od 14%
                    //4e/t/%
                    if (moisture > 14) dryingCosts = Math.round(4*quantity/1000*(moisture-14));

                    //kalo i rastur 0.5% na prijemu robe
                    if (transactionType === TransactionType.Export) {
                        dispersal = 0;
                    } else {
                        dispersal = soyaSettings?.calculateCalo === true ? Math.round((quantity * 0.5) / 100) : 0;
                    };

                    srpsQuantity = Math.round(quantity * (100 + moisturePerc + impurityPerc) / 100) - dispersal;
                }
                else srpsQuantity = Math.round(quantity);
                break;
            };

            case MercantileType.Corn: {
                const cornSettings = settings.find((product) => product.mercantile === MercantileType.Corn);

                //lom bez pozitivne bonifikacije, negativna bonifikacija po metodu 1:0.5
                //obracun loma
                const breakagePerc = breakage < parseFloat(cornSettings?.breakage) ? 0 : (parseFloat(cornSettings?.breakage) - breakage) / 2;
                percentBreakage = breakagePerc;
                quantityBreakage = Math.round((breakagePerc * quantity) / 100);

                //defekt bez pozitivne bonifikacije, negativna bonifikacija po metodu 1:1
                //obracun defektnih zrna
                const defectPerc = defect < parseFloat(cornSettings?.defect) ? 0 : (parseFloat(cornSettings?.defect) - defect);
                percentDefect = defectPerc;
                quantityDefect = Math.round((defectPerc * quantity) / 100);

                //obracun primesa bez pozitivne bonifikacije, negativna bonifikacija po metodu 1:1
                const impurityPerc = impurity < parseFloat(cornSettings?.impurity) ? 0 : (parseFloat(cornSettings?.impurity) - impurity);
                percentImpurity = impurityPerc;
                quantityImpurity = Math.round((impurityPerc * quantity) / 100);

                //medjuobracun, bez odbitka vlage
                let temporaryQuantity = quantity;
                //obracun vlage - negativna bonifikacija

                //prvobitni tablicni obracun promenjen 08.09.23.
                //tabelarni obracun primenjen ponovo od 08.09.25.
                //if (moisture > 14.5 && moisture <= 15) temporaryQuantity *= (100 - 1.16)/100;
                if (moisture > 15 && moisture <= 15.5) temporaryQuantity *= (100 - 1.74)/100;
                if (moisture > 15.5 && moisture <= 16) temporaryQuantity *= (100 - 2.33)/100;
                if (moisture > 16 && moisture <= 16.5) temporaryQuantity *= (100 - 2.91)/100;
                if (moisture > 16.5 && moisture <= 17) temporaryQuantity *= (100 - 3.49)/100;
                if (moisture > 17 && moisture <= 17.5) temporaryQuantity *= (100 - 4.07)/100;
                if (moisture > 17.5 && moisture <= 18) temporaryQuantity *= (100 - 4.65)/100;
                if (moisture > 18 && moisture <= 18.5) temporaryQuantity *= (100 - 5.23)/100;
                if (moisture > 18.5 && moisture <= 19) temporaryQuantity *= (100 - 5.81)/100;
                if (moisture > 19 && moisture <= 19.5) temporaryQuantity *= (100 - 6.40)/100;
                if (moisture > 19.5 && moisture <= 20) temporaryQuantity *= (100 - 6.98)/100;
                if (moisture > 20 && moisture <= 20.5) temporaryQuantity *= (100 - 7.56)/100;
                if (moisture > 20.5 && moisture <= 21) temporaryQuantity *= (100 - 8.14)/100;
                if (moisture > 21 && moisture <= 21.5) temporaryQuantity *= (100 - 8.72)/100;
                if (moisture > 21.5 && moisture <= 22) temporaryQuantity *= (100 - 9.30)/100;
                if (moisture > 22 && moisture <= 22.5) temporaryQuantity *= (100 - 9.88)/100;
                if (moisture > 22.5 && moisture <= 23) temporaryQuantity *= (100 - 10.47)/100;
                if (moisture > 23 && moisture <= 23.5) temporaryQuantity *= (100 - 11.05)/100;
                if (moisture > 23.5 && moisture <= 24) temporaryQuantity *= (100 - 11.63)/100;
                quantityMoisture = Math.round(temporaryQuantity - quantity);

                //novi obracun vlage, uveden 08.09.23.
                //vlaga se ne racuna do 14.5%
                // if (moisture > 14.5) {
                //     quantityMoisture = (((100 - moisture)/(100-cornSettings.moisture))*quantity) - quantity;
                //     temporaryQuantity = quantity*1 + quantityMoisture*1;
                // }

                //kalo i rastur 0.5% na prijemu robe
                if (transactionType === TransactionType.Export) {
                    dispersal = 0;
                } else {
                    dispersal = cornSettings?.calculateCalo === true ? Math.round((temporaryQuantity * 0.5) / 100) : 0;
                }

                temporaryQuantity -= dispersal;

                //trosak susenja
                //if (moisture > 14.5 && moisture <= 15) dryingCosts = temporaryQuantity * 3.00/100;
                if (moisture > 15 && moisture <= 15.5) dryingCosts = temporaryQuantity * 4.10/100;
                if (moisture > 15.5 && moisture <= 16) dryingCosts = temporaryQuantity * 5.00/100;
                if (moisture > 16 && moisture <= 16.5) dryingCosts = temporaryQuantity * 5.90/100;
                if (moisture > 16.5 && moisture <= 17) dryingCosts = temporaryQuantity * 7.00/100;
                if (moisture > 17 && moisture <= 17.5) dryingCosts = temporaryQuantity * 8.00/100;
                if (moisture > 17.5 && moisture <= 18) dryingCosts = temporaryQuantity * 9.00/100;
                if (moisture > 18 && moisture <= 18.5) dryingCosts = temporaryQuantity * 9.80/100;
                if (moisture > 18.5 && moisture <= 19) dryingCosts = temporaryQuantity * 10.70/100;
                if (moisture > 19 && moisture <= 19.5) dryingCosts = temporaryQuantity * 11.50/100;
                if (moisture > 19.5 && moisture <= 20) dryingCosts = temporaryQuantity * 12.20/100;
                if (moisture > 20 && moisture <= 20.5) dryingCosts = temporaryQuantity * 14.00/100;
                if (moisture > 20.5 && moisture <= 21) dryingCosts = temporaryQuantity * 15.00/100;
                if (moisture > 21 && moisture <= 21.5) dryingCosts = temporaryQuantity * 16.30/100;
                if (moisture > 21.5 && moisture <= 22) dryingCosts = temporaryQuantity * 17.40/100;
                if (moisture > 22 && moisture <= 22.5) dryingCosts = temporaryQuantity * 18.30/100;
                if (moisture > 22.5 && moisture <= 23) dryingCosts = temporaryQuantity * 19.50/100;
                if (moisture > 23 && moisture <= 23.5) dryingCosts = temporaryQuantity * 20.70/100;
                if (moisture > 23.5 && moisture <= 24) dryingCosts = temporaryQuantity * 22.00/100;

                srpsQuantity = Math.round(temporaryQuantity + (quantity * (breakagePerc + defectPerc + impurityPerc) / 100));
                break;
            };
            default: srpsQuantity = quantity;
        };
    }

    return [
        srpsQuantity,
        percentMoisture,
        quantityMoisture,
        percentImpurity,
        quantityImpurity,
        percentHectoliter,
        quantityHectoliter,
        percentBreakage,
        quantityBreakage,
        percentDefect,
        quantityDefect,
        dryingCosts,
        dispersal,
    ];
};